import React from "react";

export default function PageHeader({ title, total, stats, children }) {
  const colsClass = stats && stats.length ? `sm:grid-cols-${Math.min(stats.length, 4)}` : 'sm:grid-cols-3';
  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 md:p-6">
      <div className="flex items-center justify-between gap-4">
        <div className="text-right">
          <div className=" text-3xl text-gray-500">{title}</div>
          <div className="text-m md:text-m font-bold text-[#1D2035]">
            {total?.toLocaleString()}
          </div>
        </div>
        {/* Left: actions/filters (in RTL it appears visually on the left) */}
        <div className="flex items-center gap-2 md:gap-3">{children}</div>
      </div>

      {/* Mini stats row */}
      {stats && stats.length > 0 && (
        <div className={`grid grid-cols-1 ${colsClass} gap-3 md:gap-4 mt-4`}>
          {stats.map((s, idx) => {
            const value = typeof s.value === 'number' ? s.value : (s.value ?? 0);
            const deltaNum = Number(s.delta) || 0;
            const isPositive = deltaNum >= 0;
            const deltaAbs = Math.abs(deltaNum);
            // format delta with up to 2 decimals, but drop trailing .00
            const deltaAbsDisplay = Number.isFinite(deltaAbs)
              ? deltaAbs.toFixed(2).replace(/\.00$/, "")
              : deltaAbs;
            const deltaDisplay = `${isPositive ? '+' : '-'}${deltaAbsDisplay}%`;
            const deltaClass = isPositive
              ? 'inline-flex items-center gap-1 px-1 rounded bg-green-50 text-green-700 border border-green-200'
              : 'inline-flex items-center gap-1 px-1 rounded bg-red-50 text-red-700 border border-red-200';

            return (
              <div key={idx} className="rounded-2xl border border-gray-200  p-3 md:p-4">
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-2">
                    <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl text-white" style={{ background: s.iconBg }}>
                      {s.icon}
                    </span>
                    <div>
                      <div className="text-sm text-[#1D2035]">{s.title}</div>
                      <div className=" font-semibold text-[#1D2035]">{typeof value === 'number' ? value.toLocaleString() : value}</div>
                    </div>
                  </div>
                  <button className="w-8 h-8 grid place-items-center rounded-lg bg-white text-gray-500">…</button>
                </div>
                <div className="mt-3 flex items-end justify-between">
                  <span className={deltaClass}>{deltaDisplay}</span>
                  <div className="mb-1 text-gray-500">من الشهر الماضي</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
